/* eslint-disable */
import requestRawBasic from '@/utils/requestRawBasic'
import { APICore } from '@/utils/servicesApi'
const qs = require('qs')

export function getPublicList(data) {
  return requestRawBasic({
    url: APICore() + '/product/list',
    method: 'POST',
    data: data // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/product.js